module.exports = __webpack_public_path__ + "static/img/product_images_big_h5_zh.fd5ccbb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product_images_big_h5_zh.png
// module id = /CHB
// module chunks = 34